// public/js/components/customization/bannerManager.js

import { getAuth } from 'https://www.gstatic.com/firebasejs/9.23.0/firebase-auth.js';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'https://www.gstatic.com/firebasejs/9.23.0/firebase-storage.js';
import { getFunctions, httpsCallable } from 'https://www.gstatic.com/firebasejs/9.23.0/firebase-functions.js';
import { getApp } from 'https://www.gstatic.com/firebasejs/9.23.0/firebase-app.js';
import { saveUserProfile, getUserProfile } from '../../modules/firestore/firestoreService.js';
import { addNotification } from '../ezViewManager.js';
import { showCustomModal } from '../../modules/modalManager.js';
import { captureCurrentThemeState } from '../../modules/ui/themeManager.js';


let markImageForCleanupFn;
function getMarkImageForCleanupFn() {
    if (!markImageForCleanupFn) {
        const functions = getFunctions(getApp(), 'us-east1');
        markImageForCleanupFn = httpsCallable(functions, 'markImageForCleanupCallable');
    }
    return markImageForCleanupFn;
}


async function markOldImageForCleanup(imageUrl, reason) {
    if (!imageUrl || imageUrl.includes('placehold.co')) return;
    
    try {
        const fn = getMarkImageForCleanupFn();
        await fn({ imageUrl, reason });
        console.log(`[Banner Manager] Marked old image for cleanup: ${reason}`);
    } catch (error) {
        console.warn(`[Banner Manager] Failed to mark image for cleanup: ${error.message}`);
        
    }
}


export const PREDEFINED_BANNERS = [
    'https://firebasestorage.googleapis.com/v0/b/f8lyss-music-app-63fb7.firebasestorage.app/o/Bloodlust.png?alt=media&token=3bcae4a3-93c0-48d2-ad7d-0868bdd6a566',
    'https://firebasestorage.googleapis.com/v0/b/f8lyss-music-app-63fb7.firebasestorage.app/o/Goldseen.png?alt=media&token=a7c8d506-df1e-43cc-b2a3-d260cec2ff7d',
    'https://firebasestorage.googleapis.com/v0/b/f8lyss-music-app-63fb7.firebasestorage.app/o/Bannerisms.png?alt=media&token=7c8471f4-9c70-4f85-af64-64ce8cc3cf6d',
    'https://firebasestorage.googleapis.com/v0/b/f8lyss-music-app-63fb7.firebasestorage.app/o/balloony.png?alt=media&token=6edd90a1-b52d-4e6d-98e4-711827e6eaa0',
    'https://firebasestorage.googleapis.com/v0/b/f8lyss-music-app-63fb7.firebasestorage.app/o/bgconsole.png?alt=media&token=6e33a514-e211-41f9-be1a-72fb0c0976a1',
    'https://firebasestorage.googleapis.com/v0/b/f8lyss-music-app-63fb7.firebasestorage.app/o/cityvo.png?alt=media&token=cf58eb4a-9141-4bdc-972e-d965032dc4fd',
    'https://firebasestorage.googleapis.com/v0/b/f8lyss-music-app-63fb7.firebasestorage.app/o/shi.jpg?alt=media&token=1d2accf8-8cbe-4fd9-93cd-a27a7393b110',
    'https://firebasestorage.googleapis.com/v0/b/f8lyss-music-app-63fb7.firebasestorage.app/o/Ferris.jpg?alt=media&token=4010a686-1154-4415-9e69-c2f11a32a748',
    'https://firebasestorage.googleapis.com/v0/b/f8lyss-music-app-63fb7.firebasestorage.app/o/Plumbum.jpg?alt=media&token=4352e538-f913-4a56-af49-3b2721a82dff',
    'https://firebasestorage.googleapis.com/v0/b/f8lyss-music-app-63fb7.firebasestorage.app/o/autumnleaves.jpg?alt=media&token=6587acd2-c5f0-4641-b15f-3c9a771a3b74',
    'https://firebasestorage.googleapis.com/v0/b/f8lyss-music-app-63fb7.firebasestorage.app/o/blighty.jpg?alt=media&token=1ea93cf6-5341-4e4e-a051-54a97869287f',
    'https://firebasestorage.googleapis.com/v0/b/f8lyss-music-app-63fb7.firebasestorage.app/o/bulbo.jpg?alt=media&token=c8cf84b2-2353-40da-920d-a52479435c63',
    'https://firebasestorage.googleapis.com/v0/b/f8lyss-music-app-63fb7.firebasestorage.app/o/cardorama.jpg?alt=media&token=5be27a78-c152-48d0-88b0-91396ef91e78',
    'https://firebasestorage.googleapis.com/v0/b/f8lyss-music-app-63fb7.firebasestorage.app/o/churchlight.jpg?alt=media&token=f2f48e73-de79-44a3-9e51-b6e819cf54ef',
    'https://firebasestorage.googleapis.com/v0/b/f8lyss-music-app-63fb7.firebasestorage.app/o/flowgg.jpg?alt=media&token=eaed90b5-a91b-4912-a209-6b476e1c1c8c',
    'https://firebasestorage.googleapis.com/v0/b/f8lyss-music-app-63fb7.firebasestorage.app/o/gridz.jpg?alt=media&token=1c25d53e-5c15-4c5c-a8c1-0d3d604b282a',
    'https://firebasestorage.googleapis.com/v0/b/f8lyss-music-app-63fb7.firebasestorage.app/o/pinkyplanet.jpg?alt=media&token=8847c9a4-6cac-41ca-97bb-328a7fd6c793',
    'https://firebasestorage.googleapis.com/v0/b/f8lyss-music-app-63fb7.firebasestorage.app/o/redspace.jpg?alt=media&token=88badeda-7f90-419d-a6cd-0a93cfcdbb5b',
    'https://firebasestorage.googleapis.com/v0/b/f8lyss-music-app-63fb7.firebasestorage.app/o/Garchs.png?alt=media&token=bbc956d2-f30e-4ca7-b48b-2c8766c545bf'
];


export const PREDEFINED_BACKGROUNDS = [
    'https://firebasestorage.googleapis.com/v0/b/f8lyss-music-app-63fb7.firebasestorage.app/o/BGChat.png?alt=media&token=414075fb-a72e-46a1-b806-506ca7c1f04f',
    'https://firebasestorage.googleapis.com/v0/b/f8lyss-music-app-63fb7.firebasestorage.app/o/BGChat1.png?alt=media&token=7853d9cf-d469-4269-8ecb-0963ede90c3c',
    'https://firebasestorage.googleapis.com/v0/b/f8lyss-music-app-63fb7.firebasestorage.app/o/BGChat2.png?alt=media&token=ec3c027e-d66b-4285-a764-8eee8353bf09',
    'https://firebasestorage.googleapis.com/v0/b/f8lyss-music-app-63fb7.firebasestorage.app/o/BGChat3.png?alt=media&token=2ed2c12b-9da4-4d0f-8d3b-689af2ff918f',
    'https://firebasestorage.googleapis.com/v0/b/f8lyss-music-app-63fb7.firebasestorage.app/o/BGChat4.png?alt=media&token=1b08cc6e-f38a-4274-91d9-06a899fff004',
    'https://firebasestorage.googleapis.com/v0/b/f8lyss-music-app-63fb7.firebasestorage.app/o/BGChat5.png?alt=media&token=da0b1091-d1db-47cc-84b1-9ee3b0a0f543',
    'https://firebasestorage.googleapis.com/v0/b/f8lyss-music-app-63fb7.firebasestorage.app/o/BGChat6.png?alt=media&token=f2a7e4f6-e8b5-463c-a077-1119eaee6439',
    'https://firebasestorage.googleapis.com/v0/b/f8lyss-music-app-63fb7.firebasestorage.app/o/BGChat7.png?alt=media&token=39f104c3-b603-4d50-9411-3c6933106d7e',
    'https://firebasestorage.googleapis.com/v0/b/f8lyss-music-app-63fb7.firebasestorage.app/o/BGChat8.png?alt=media&token=b853ac4d-6214-43a2-b2d4-b7824e541a8c',
    'https://firebasestorage.googleapis.com/v0/b/f8lyss-music-app-63fb7.firebasestorage.app/o/BGChat9.png?alt=media&token=80597746-ce22-40ef-b868-ca61e80826cf',
    'https://firebasestorage.googleapis.com/v0/b/f8lyss-music-app-63fb7.firebasestorage.app/o/BGChat10.png?alt=media&token=beeedf02-bf84-4be2-9113-5abca225bc7e',
    'https://firebasestorage.googleapis.com/v0/b/f8lyss-music-app-63fb7.firebasestorage.app/o/BGChat11.png?alt=media&token=c48b9c23-76f5-47ae-ab6a-fc5d85f2f3da',
    'https://firebasestorage.googleapis.com/v0/b/f8lyss-music-app-63fb7.firebasestorage.app/o/BGChat12.png?alt=media&token=2b6e5d61-771b-4136-a5a6-bac0ec73a74b'
];


export function applyBanner(url) {
    const headerBannerImg = document.getElementById('header-banner-img');
    const userBannerImg = document.getElementById('user-banner-img');
    const accountPreview = document.getElementById('account-banner-preview');
    
    const finalUrl = url || 'https://placehold.co/300x70/111827/4b5563?text=Banner';

    
    
    

    
    if (headerBannerImg) {
        headerBannerImg.style.display = 'none';
    }

    
    if (userBannerImg) {
        userBannerImg.src = finalUrl;
    }

    if (accountPreview) {
        accountPreview.src = finalUrl;
    }
}


export async function selectAndSaveBanner(url) {
    const user = getAuth().currentUser;
    if (!user) return;
    try {
        const profile = await getUserProfile(user.uid);
        const oldBannerUrl = profile?.bannerUrl;
        const isOldCustomBanner = oldBannerUrl && !PREDEFINED_BANNERS.includes(oldBannerUrl);
        
        await saveUserProfile(user.uid, { bannerUrl: url });
        
        const themeState = captureCurrentThemeState();
        
        if (profile?.preferences?.activeScheme) {
            const activeTheme = { 
                ...profile.preferences.activeScheme, 
                bannerUrl: url,
                colors: themeState.colors
            };
            await saveUserProfile(user.uid, { 'preferences.activeScheme': activeTheme });
        } else {
            const newActiveTheme = {
                bannerUrl: url,
                backgroundUrl: themeState.backgroundUrl,
                colors: themeState.colors,
                shadingLevel: themeState.shadingLevel || 2
            };
            await saveUserProfile(user.uid, { 'preferences.activeScheme': newActiveTheme });
        }
        
        applyBanner(url);
        addNotification("Your banner has been updated!", { type: 'success' });
        
        if (isOldCustomBanner && oldBannerUrl !== url) {
            await markOldImageForCleanup(oldBannerUrl, 'replaced_banner');
        }
    } catch (error) {
        console.error("Error saving banner:", error);
        addNotification("Failed to save your new banner.", { type: 'alert' });
    }
}


export async function handleCustomBannerUpload(file, onCompleteCallback = null) {
    const user = getAuth().currentUser;
    if (!user || !file) return;

    if (file.size > 2 * 1024 * 1024) {
        showCustomModal("File size cannot exceed 2MB.", { type: 'alert' });
        return;
    }

    const storage = getStorage();
    const storageRef = ref(storage, `users/${user.uid}/banners/custom_banner_${Date.now()}`);
    
    try {
        await uploadBytes(storageRef, file);
        const downloadURL = await getDownloadURL(storageRef);
        
        if (onCompleteCallback) {
            onCompleteCallback(downloadURL);
        } else {
            await selectAndSaveBanner(downloadURL);
        }

    } catch (error) {
        console.error("Error uploading custom banner:", error);
        addNotification("Failed to upload custom banner.", { type: 'alert' });
        if (onCompleteCallback) {
            onCompleteCallback(null);
        }
    }
}


export function applyBackground(url) {
    const splitContainer = document.getElementById('chat-split-container');
    const accountPreview = document.getElementById('account-background-preview');
    const customizerBody = document.getElementById('customizer-body');

    const finalUrl = url || '';

    
    
    if (splitContainer) {
        if (finalUrl) {
            splitContainer.style.setProperty('background-image', `url('${finalUrl}')`, 'important');
            splitContainer.style.setProperty('background-size', 'cover', 'important');
            splitContainer.style.setProperty('background-position', 'center', 'important');
            splitContainer.style.setProperty('background-repeat', 'no-repeat', 'important');
            
            splitContainer.style.setProperty('background-attachment', 'scroll', 'important');
        } else {
            splitContainer.style.removeProperty('background-image');
            splitContainer.style.removeProperty('background-size');
            splitContainer.style.removeProperty('background-position');
            splitContainer.style.removeProperty('background-repeat');
            splitContainer.style.removeProperty('background-attachment');
        }
    }

    if (customizerBody) {
        if (finalUrl) {
            customizerBody.style.backgroundImage = `url('${finalUrl}')`;
            customizerBody.style.backgroundSize = 'cover';
        } else {
            customizerBody.style.backgroundImage = '';
            customizerBody.style.backgroundSize = '';
        }
    }

    if (accountPreview) {
        if (finalUrl) {
            accountPreview.src = finalUrl;
        } else {
            accountPreview.src = 'https://placehold.co/80x80/1f2937/4b5563?text=+';
        }
    }

    applyBackgroundToAllDMFeeds(finalUrl);
}

function applyBackgroundToAllDMFeeds(url) {
    const dmFeedWrappers = document.querySelectorAll('.dm-feed-wrapper');
    dmFeedWrappers.forEach(wrapper => {
        if (url) {
            wrapper.style.setProperty('background-image', `url('${url}')`, 'important');
            wrapper.style.setProperty('background-size', '100% 100%', 'important');
            wrapper.style.setProperty('background-position', 'center', 'important');
            wrapper.style.setProperty('background-repeat', 'no-repeat', 'important');
            wrapper.style.setProperty('background-color', 'var(--color-windows-bg)', 'important');
        } else {
            wrapper.style.backgroundImage = '';
        }
    });
}

export function applyBackgroundToDMFeed(wrapper, url) {
    if (!wrapper) return;
    
    if (url) {
        wrapper.style.setProperty('background-image', `url('${url}')`, 'important');
        wrapper.style.setProperty('background-size', '100% 100%', 'important');
        wrapper.style.setProperty('background-position', 'center', 'important');
        wrapper.style.setProperty('background-repeat', 'no-repeat', 'important');
        wrapper.style.setProperty('background-color', 'var(--color-windows-bg)', 'important');
    } else {
        wrapper.style.backgroundImage = '';
    }
}


export async function selectAndSaveBackground(url) {
    const user = getAuth().currentUser;
    if (!user) return;
    try {
        const profile = await getUserProfile(user.uid);
        const oldBackgroundUrl = profile?.chatBackgroundUrl;
        
        const isOldCustomBackground = oldBackgroundUrl && !PREDEFINED_BACKGROUNDS.includes(oldBackgroundUrl);
        
        const themeState = captureCurrentThemeState();
        
        if (profile?.preferences?.activeScheme) {
            const activeTheme = {
                ...profile.preferences.activeScheme, 
                backgroundUrl: url,
                colors: themeState.colors
            };
            await saveUserProfile(user.uid, { 'preferences.activeScheme': activeTheme });
        } else {
            const newActiveTheme = {
                bannerUrl: themeState.bannerUrl,
                backgroundUrl: url,
                colors: themeState.colors,
                shadingLevel: themeState.shadingLevel || 2
            };
            await saveUserProfile(user.uid, { 'preferences.activeScheme': newActiveTheme });
        }
        
        applyBackground(url);
        addNotification("Your chat background has been updated!", { type: 'success' });
        
        if (isOldCustomBackground && oldBackgroundUrl !== url) {
            await markOldImageForCleanup(oldBackgroundUrl, 'replaced_chat_background');
        }
    } catch (error) {
        console.error("Error saving background:", error);
        addNotification("Failed to save your new background.", { type: 'alert' });
    }
}


export async function handleCustomBackgroundUpload(file, onCompleteCallback = null) {
    const user = getAuth().currentUser;
    if (!user || !file) return;

    if (file.size > 2 * 1024 * 1024) {
        showCustomModal("File size cannot exceed 2MB.", { type: 'alert' });
        return;
    }

    const storage = getStorage();
    const storageRef = ref(storage, `users/${user.uid}/backgrounds/custom_background_${Date.now()}`);
    
    try {
        await uploadBytes(storageRef, file);
        const downloadURL = await getDownloadURL(storageRef);
        
        if (onCompleteCallback) {
            onCompleteCallback(downloadURL);
        } else {
            await selectAndSaveBackground(downloadURL);
        }

    } catch (error) {
        console.error("Error uploading custom background:", error);
        addNotification("Failed to upload custom background.", { type: 'alert' });
        if (onCompleteCallback) {
            onCompleteCallback(null);
        }
    }
}
